import type { ReactElement } from 'react'

import GoogleLogo from '~/assets/google-logo.png'
import MwMLogoSmall from '~/assets/mwm-logo-small.png'
import RotatingLogo from '~/components/RotatingLogo'
import config from '~/config'
import useDocumentTitle from '~/hooks/useDocumentTitle'
import { CLIENT_ID } from '~/utils/env'

import './styles.scss'

const Login = (): ReactElement => {
  useDocumentTitle('Login')

  return (
    <div className="login-view">
      <div className="login-view__background-container">
        <RotatingLogo size={window.innerHeight} />
      </div>
      <div className="login-view__login-container">
        <img className="login-view__login-container__mwm-logo" src={MwMLogoSmall} />
        <h1 className="login-view__login-container__title">
          Connect to
          <br />
          MWM Intranet
        </h1>
        <div>
          <a
            className="login-view__login-container__google-button"
            href={`${config.AUTHORIZATION_API}/google/redirect?client=${CLIENT_ID}&redirect_uri=${window.location.origin}${window.location.pathname}`}
          >
            <div className="google-logo">
              <img alt="" src={GoogleLogo} />
            </div>
            Continue with Google
          </a>
        </div>
      </div>
    </div>
  )
}

export default Login
